import { Component, input, viewChild } from '@angular/core';
import { SharedModule } from '../../../../../Shared/shared.module';
import { ICMSResourceQuery } from '../../cms.model';
import { inject } from '@angular/core';
import { CMSService } from '../../cms.service';
import { catchError, of, switchMap } from 'rxjs';

import { PageTemplateComponent } from '../../../../../Shared/components/page-template/page-template.component';
import { CMSResourceComponent } from '../cms-resource/cms-resource.component';
import { CMSLayoutService } from '../../cms-layout/cms-layout.service';
import { CMSResourceService } from '../cms-resource/cms-resource.service';
import { rxResource, toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'view-cms-resource',
  standalone: true,
  imports: [SharedModule, CMSResourceComponent],
  providers: [CMSResourceService],
  templateUrl: './view-cms-resource.component.html',
  styleUrl: './view-cms-resource.component.scss',
})
export default class ViewCMSResourceComponent extends PageTemplateComponent {
  readonly service = inject(CMSService);
  readonly cmsLayoutService = inject(CMSLayoutService);

  readonly allowEdit = input<boolean>(true);
  readonly hideOutline = input<boolean>();
  readonly query = input<ICMSResourceQuery>();

  readonly routeQuery = toSignal<ICMSResourceQuery>(this.route.queryParams);
  readonly contentResource = rxResource({
    params: () => (this.query() ? this.query() : this.routeQuery()),
    stream: ({ params }) =>
      this.service.getContentResource(params).pipe(
        switchMap((r) =>
          r || !params.helpGuideContentId ? of(r) : this.service.getContentById(params.helpGuideContentId),
        ),
        catchError((e) => {
          this.service.uS.info('Content could not be loaded', 0);
          throw e;
        }),
      ),
  });
  protected cmsResourceComponentRef = viewChild(CMSResourceComponent);

  async ngOnInit(): Promise<void> {
    this.cmsLayoutService.setTitle(`View Help Resource`);
  }

  download() {
    this.cmsResourceComponentRef()?.download();
  }

  ngOnDestroy(): void {
    this.cmsLayoutService.setTitle(null);
  }
}
